import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useFamilyAllowanceChartsDataContext } from './hooks/useFamilyAllowanceChartsDataContext';

export const AverageValuePerYear = () => {
    const { chartData } = useFamilyAllowanceChartsDataContext();

    const rawData = chartData?.averageValues?.annual || [];

    const series = [
        {
            name: 'Valor Médio por Família',
            data: rawData.map(item => Number(item.value))
        }
    ];

    return (
        <SimpleBars
            title="Valor Médio por Família - Mensal"
            horizontal={false}
            subtitles={rawData.map(item => getYearLabel(item.ano))}
            series={series}
        />
    );
};
